export default __webpack_public_path__ + "static/media/omkar-sunku.92bbd18c.png";